// Completed By Rabbil Hasan
// 14-05-2014 5:43AM
import React, { Component, Fragment } from "react";
import TopNavigation from "../../Components/Common/TopNavigation";
import HowToPurchase from "../../Components/HowToPurchase/HowToPurchase";
import Footer from "../../Components/Common/Footer";
class HowToPurchasePage extends Component {
  componentDidMount() {
    window.scroll(0, 0);
  }
  render() {
    return (
      <Fragment>
        <TopNavigation />
        <div className="responsive-padding-top">
          <HowToPurchase />
        </div>
        <Footer />
      </Fragment>
    );
  }
}
export default HowToPurchasePage;
